import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { fetchHandler } from '../../../../../../../../util/fetchHandler';
import Util from '../../../../../../../../util/util';
import { getRestHeadersGet } from '../../../../../../../../rest/helpers/getRestHeadersHelper';
import { IGetState } from '../../../../../../../../types/types';
import { ICardDetailsData } from '../../../../cardDetails/components/CardDetails/types';
import {
    IRestModelHistory,
    IRestPushNotificationItem
} from '../../../../../../../../types/rest/IRestPushNotificationItem';
import { loadData } from '../../../../helpers/loadData';
import { cardsIsLoadingUpdate } from '../../../../../../../../store/requestsState/effects/cardsIsLoadingUpdate';
import { getRest } from '../../../../../../../../rest/effects/card/card/api/getRest';
import { IRestCard } from '../../../../../../../../types/rest/IRestCard';
import { getList } from '../../../../../../../../store/model/list/selectors/getList';
import { showRecordNotFoundError } from '../../../../helpers/showRecordNotFoundError';

export const NOTIFICATION_CARD_ID_SESSIONSTORAGE = 'NOTIFICATION_CARD_ID_SESSIONSTORAGE';

export const onLoadData = (
    notificationId: number
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ): Promise<ICardDetailsData> => {
        return fetchHandler<IRestPushNotificationItem>(
            Util.getApiUrl('/rest/pushnotification/' + notificationId), {
                ...getRestHeadersGet(),
            }
        ).then(notification => {
            const modelHistory: IRestModelHistory[] = JSON.parse(notification.modelHistoryJson);
            const cardId = modelHistory[0].card.id;
            sessionStorage.setItem(NOTIFICATION_CARD_ID_SESSIONSTORAGE, JSON.stringify(cardId));
            dispatch(cardsIsLoadingUpdate({ [cardId]: {} }, true)); // флаг должен сняться в cardFullGetRest
            return loadData(getState(), modelHistory[0].dashboardId, cardId)
                .then((result) => {
                    return dispatch(getRest(cardId)).then((card: IRestCard) => {
                        const list = getList(getState(), card.listId);
                        if (!list) {
                            showRecordNotFoundError();
                            return null;
                        }
                        return {
                            boardId: list.dashboardId,
                            cardId
                        };
                    })
                })
        });
    }
    return action;
}
